import React, { Component } from 'react'
import './OwnerComplete.scss'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'

const ReportItem = ({ item }) => {
    return (
        <Link to={`/report/${item._id}`}>
            <li>
                <img src={item.thumbnailUrl} alt="thumbnail" />
            </li>
        </Link>
    )
}

class OwnerComplete extends Component {
    constructor(props) {
        super(props)

        this.state = {
            report: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadList(0)
    }

    loadList = (offset) => {
        const { cookies } = this.props
        const limit = 6

        axios
            .get(`${BACKEND_HOST}/reports/?project_id=${cookies.get('project')}&offset=${offset}&limit=${limit}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ report: res.data.docs })
                console.log(res.data.docs)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderList = () => {
        const List = this.state.report.map((item) => {
            return <ReportItem item={item} key={item._id} />
        })
        return List
    }

    render() {
        return (
            <div className="owner_complete_wrap">
                <div className="complete_top">
                    {this.props.project.thumbnailUrl && this.props.project.thumbnailUrl !== '' && (
                        <img className="top_bg" src={this.props.project.thumbnailUrl} alt="bg" />
                    )}
                    <div className="top_content">
                        <div className="title_box">
                            <h1>완공된</h1>
                            <h2>{this.props.project.title}</h2>
                            <Link to="/intro/complete">
                                <div className="link_btn">
                                    보기
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#FFF"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1.3">
                                            <path d="M1.5 6h13M9.5 1l5 5-5 5" />
                                        </g>
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

                {this.props.project.summary && (
                    <div className="house_info">
                        <div className="common_wrap">
                            <h1>HOUSE INFO</h1>
                            <Link to="/intro/">
                                <div className="info_wrap">
                                    <img src={this.props.project.thumbnailUrl} alt="house" />
                                    <div className="info_text">
                                        <div className="more_btn">
                                            더 보기
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="7"
                                                height="12"
                                                viewBox="0 0 7 12">
                                                <path
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    stroke="#6D7075"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.2"
                                                    d="M1 1.5L6 6l-5 4.5"
                                                />
                                            </svg>
                                        </div>
                                        <ul>
                                            <div className="li_wrap_left">
                                                <li>
                                                    <p className="info_title">대지위치</p>
                                                    <p className="info_content">{this.props.project.summary.address}</p>
                                                </li>
                                                <li>
                                                    <p className="info_title">공사기간</p>
                                                    <p className="info_content">
                                                        {this.props.project.summary.schedule}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p className="info_title">연면적</p>
                                                    <p className="info_content">{this.props.project.summary.area}</p>
                                                </li>
                                            </div>
                                            <div className="li_wrap_right">
                                                {/* <li>
                          <p className="info_title">건축비</p>
                          <p className="info_content">{this.props.project.summary.budget}</p>
                        </li> */}
                                                <li>
                                                    <p className="info_title">설계</p>
                                                    <p className="info_content">
                                                        {this.props.project.summary.architect}
                                                    </p>
                                                </li>
                                                <li>
                                                    <p className="info_title">시공</p>
                                                    <p className="info_content">{this.props.project.summary.builder}</p>
                                                </li>
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                )}

                {this.state.report && (
                    <div className="archi_diary">
                        <div className="common_wrap">
                            <h1>ARCHI DIARY</h1>
                            <ul>{this.renderList()}</ul>
                            <Link to={'/report/'}>
                                <div className="list_btn">
                                    더 보기
                                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12">
                                        <path
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#6D7075"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1.2"
                                            d="M1 1.5L6 6l-5 4.5"
                                        />
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default withCookies(OwnerComplete)



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerComplete.js